export enum OfficeOrderBy {
  id = 'id'
}
